var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingglass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.9700 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78906-42.2363C8.78906-25.0977 22.7051-11.2305 39.8438-11.2305C46.4355-11.2305 52.4902-13.2812 57.5195-16.7969L75.6836 1.41602C76.709 2.39258 77.9785 2.83203 79.2969 2.83203C82.1289 2.83203 84.1797 0.683594 84.1797-2.14844C84.1797-3.51562 83.6426-4.73633 82.8125-5.66406L64.7461-23.7793C68.6035-28.9551 70.8496-35.3027 70.8496-42.2363C70.8496-59.375 56.9824-73.291 39.8438-73.291C22.7051-73.291 8.78906-59.375 8.78906-42.2363ZM16.3086-42.2363C16.3086-55.2734 26.8066-65.7715 39.8438-65.7715C52.832-65.7715 63.3789-55.2734 63.3789-42.2363C63.3789-29.248 52.832-18.7012 39.8438-18.7012C26.8066-18.7012 16.3086-29.248 16.3086-42.2363Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingglass);
export default __webpack_public_path__ + "static/media/magnifyingglass.bdf24ca8254f3a8d14ad8057e4c5a584.svg";
export { ForwardRef as ReactComponent };